module.exports = __webpack_public_path__ + "img/command.56005a0f.svg";